var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showFlatfinder)?_c('Flatfinder',_vm._b({staticClass:"kpb-flatfinder",attrs:{"value":_vm.data.flatfinders,"properties":_vm.properties,"suggested":_vm.$path('suggestedFlatfinder', _vm.data)},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._t("top")]},proxy:true}],null,true)},'Flatfinder',_vm.$attrs,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }